import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../providers/AuthUserProvider';
import { CoenergyUserRole } from '../types/CoenergyUserRole';
import { hasAuthSession } from '../utils/authTokenStorage';

import { Loader } from './AppRoutes';
import { Paths } from './Paths';

type AppRolePrivateProps = {
  allowedRoles: CoenergyUserRole[];
  fallbackPath: string;
};

export const AppRolePrivate = ({
  allowedRoles,
  fallbackPath,
}: AppRolePrivateProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (!user && !hasAuthSession()) {
    return (
      <Navigate replace to={Paths.Login} state={{ from: location.pathname }} />
    );
  }

  if (isLoading) {
    return <Loader open />;
  }

  if (!user) {
    return <Navigate to={Paths.Login} state={{ from: location.pathname }} />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <Outlet />;
};
